import React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import QRCode from 'react-qr-code';
import { toast } from 'react-toastify';
import { Link, useParams } from 'react-router-dom';
import { User } from '../../models/user-model';
import ShortTextControl from '../../controls/short-text/short-text-control';
import './blockchain-address-component.scss';

type Params = {
  selectedAddress: string;
};

function BlockchainAddressComponent(props: { user: User }): JSX.Element {
  const { user } = props;
  const { selectedAddress } = useParams<keyof Params>() as Params;

  return (
    <div id="blockchain-address-block">
      <div>
        <div id="qr-code" className="mb-3">
          <CopyToClipboard
            text={selectedAddress}
            onCopy={() => {
              toast(`${selectedAddress} was copied to your clipboard!`);
            }}
          >
            <QRCode size={128} level="Q" value={selectedAddress} className="qr-code" />
          </CopyToClipboard>
        </div>
        <h6 className="mb-2">Blockchain Address</h6>
        <span className="d-flex align-items-center justify-content-center text-muted mainBrowsing">
          <ShortTextControl text={selectedAddress} numberOfChars={12} />
        </span>
      </div>
      {user.data?.addresses && (
        <div className="card-header bg-transparent header-elements-inline">
          <span>Casa Addresses</span>
        </div>
      )}
      <div>
        <ul className="nav nav-sidebar flex-column">
          {user.data?.addresses?.map((a) => (
            <li className="nav-item" key={a.address}>
              <Link to={`/wallet/${a.address}`} className="nav-link walletLink active">
                <div id="blockchain-image-container">
                  <div id={`${a.blockchain}`} className="blockchain-image" />
                  <ShortTextControl text={a.address} numberOfChars={12} />
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default BlockchainAddressComponent;
